import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import IconButton from '@material-ui/core/IconButton';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

export const ButtonNewTab = ({ texto, url, legenda }) => {
    return (
      <>
        {texto}
        <Tooltip title={legenda} TransitionComponent={Zoom}>
            <IconButton 
                size="small"
                color="primary" 
                component="a"
                href={url}
                target="_blank"
                aria-label={legenda}
            >
                <OpenInNewIcon fontSize="small" />
            </IconButton>
        </Tooltip>
      </>
    )
}

export const ButtonNewTabCandidatosPorInep = ({ inep, query = "" }) => 
  <ButtonNewTab 
    texto={inep}
    legenda="Ver Candidato"
    url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?inep=${inep}${query}`}
  />

export const ButtonNewTabCandidatos = ({ qtd, query = "" }) => 
  <>
    {qtd > 0?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?${query}`}

      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorStatus = ({ qtd, status, query = "" }) =>
  <>
    {qtd > 0 && status ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?status=${status}${query}`}
      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorDepAdminAndStatus = ({ qtd, depAdmin, status, query = "" }) =>
  <>
    {qtd > 0 && depAdmin && status ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?depAdmin=${depAdmin}&status=${status}${query}`}
      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorDepAdmin = ({ qtd, depAdmin, query = "" }) =>
  <>
    {qtd > 0 && depAdmin ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?depAdmin=${depAdmin}${query}`}
      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorUf = ({ qtd, uf, query = "" }) => 
  <>
    {qtd > 0 && uf ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?uf=${uf}${query}`}
      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorUfAndStatus = ({ qtd, uf, status, query = "" }) =>
  <>
    {qtd > 0 && uf && status ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?uf=${uf}&status=${status}${query}`}
      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorUfAndDepAdmin = ({ qtd, uf, depAdmin, query = "" }) => 
  <>
    {qtd > 0 && uf && depAdmin ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?uf=${uf}&depAdmin=${depAdmin}${query}`}
      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorMunicipio = ({ qtd, municipio, uf, query = "" }) => 
  <>
    {qtd > 0 && uf && municipio ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?uf=${uf}&municipio=${municipio}${query}`}
      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorMunicipioAndStatus = ({ qtd, municipio, uf, status, query = "" }) =>
  <>
    {qtd > 0 && uf && municipio && status ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?uf=${uf}&municipio=${municipio}&status=${status}${query}`}
      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorMunicipioAndDepAdmin = ({ qtd, municipio, uf, depAdmin, query = "" }) =>
  <>
    {qtd > 0 && uf && municipio && depAdmin ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?uf=${uf}&municipio=${municipio}&depAdmin=${depAdmin}${query}`}
      />
    : qtd }
  </>

export const ButtonNewTabCandidatosPorDataInicioInscricaoAndStatus = ({ qtd, data, status, query = "" }) =>
  <>
    {qtd > 0 && data && status ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?dataInicioInscricao=${data}&status=${status}${query}`}
      />
    : qtd }
  </>
  
export const ButtonNewTabCandidatosPorDataFinalizacaoInscricaoAndStatus = ({ qtd, data, status, query = "" }) =>
  <>
    {qtd > 0 && data && status ?
        <ButtonNewTab 
          texto={qtd}
          legenda="Ver Candidatos"
          url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?dataFinalizacaoInscricao=${data}&status=${status}${query}`}
        />
      : qtd }
    </>

export const ButtonNewTabCandidatosPorUfAndDepAdminAndStatus = ({ qtd, uf, depAdmin, status, query = "" }) =>
  <>
    {qtd > 0 && uf && depAdmin && status ?
      <ButtonNewTab 
        texto={qtd}
        legenda="Ver Candidatos"
        url={`${process.env.REACT_APP_PUBLIC_URL}/admin/candidatos?uf=${uf}&depAdmin=${depAdmin}&status=${status}${query}`}
      />
    : qtd }
  </>

export default ButtonNewTab;